import React from 'react';
import logo from './logo.svg';
import './App.css';
import Main from './components/main'
import Helmet from 'react-helmet'

function App() {
  return (
    <main>
          <Helmet>
        {/* <!-- HTML Meta Tags --> */}
        <title>Vidriera Emprendedora Virtual</title>
        <meta
          name="description"
          content="Vidriera Emprendedora Virtual. Proyecto realizado en el marco del Programa de Fortalecimiento Institucional del ex-INAM, organizado por Red Proter y Mujeres Emprendedoras MDP."
        />

        {/* <!-- Google / Search Engine Tags --> */}
        <meta itemprop="name" content="Vidriera Emprendeora Virtual." />
        <meta
          itemprop="description"
          content="Vidriera Emprendedora Virtual. Proyecto realizado en el marco del Programa de Fortalecimiento Institucional del ex-INAM, organizado por Red Proter y Mujeres Emprendedoras MDP."
        />
        <meta
          itemprop="image"
          content={require('./components/main/assets/img/mujerse.png')}
        />

        {/* <!-- Facebook Meta Tags --> */}
        <meta property="og:url" content="https://mujeresemprendedoras-a042c.web.app/" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Vidriera Emprendedora Virtual" />
        <meta
          property="og:description"
          content="Vidriera Emprendedora Virtual. Proyecto realizado en el marco del Programa de Fortalecimiento Institucional del ex-INAM, organizado por Red Proter y Mujeres Emprendedoras MDP."
        />
        <meta
          property="og:image"
          content={require('./components/main/assets/img/mujerse.png')}
        />

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Vidriera Emprendedora Virtual" />
        <meta
          name="twitter:description"
          content="Vidriera Emprendedora Virtual. Proyecto realizado en el marco del Programa de Fortalecimiento Institucional del ex-INAM, organizado por Red Proter y Mujeres Emprendedoras MDP."
        />
        <meta
          name="twitter:image"
          content={require('./components/main/assets/img/mujerse.png')}
        />
      </Helmet>


    <div className="App">
        <Main></Main>
    </div>
    </main>
  );
}

export default App;
